// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/routes/($lang).kantonsrat.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/routes/($lang).kantonsrat.tsx");
  import.meta.hot.lastModified = "1771658398960.5977";
}
// REMIX HMR END

import { NavLink, Outlet, useLocation, useParams } from "@remix-run/react";
import { useCallback } from "react";
import SearchInputGroup from "~/components/forKantonsrat/SearchInputGroup";
import { BreadcrumbsKantonsrat } from "~/components/header/Breadcrumbs";
import SYS_CONFIG from "~/config";
import dict from "~/locales";
import { usePathHandle } from "~/utils/handle";
import { createLangPathByParam, langByParam } from "~/utils/lang";
import { createHrefLangObjForMetas } from "~/utils/metas";
import { useLang } from "~/utils/provider/lang-provider";
import { removeTrailingSlash } from "~/utils/strings";
export const headers = () => {
  return SYS_CONFIG.CACHE_CONTROL;
};
export const meta = ({
  params,
  location
}) => {
  const {
    lang
  } = params;
  const langObj = langByParam(lang);
  const {
    pathname
  } = location;
  const {
    URL_SITE_DOMAIN
  } = SYS_CONFIG;
  const metas = dict[langObj.lang_code].metas;
  return [{
    title: metas.m_t_kantonsrat
  }, {
    name: 'description',
    content: metas.m_d_kantonsrat
  }, {
    tagName: "link",
    rel: "canonical",
    href: URL_SITE_DOMAIN + removeTrailingSlash(pathname)
  }, {
    property: "og:url",
    content: URL_SITE_DOMAIN + removeTrailingSlash(pathname)
  }, {
    property: 'og:locale',
    content: langObj.lang_code
  }, {
    property: 'og:image',
    content: URL_SITE_DOMAIN + `/_static/icons/logo512x512.png`
  }, {
    property: 'og:image:width',
    content: 512
  }, {
    property: 'og:image:height',
    content: 512
  }, ...createHrefLangObjForMetas(pathname)];
};
export default function KantonsratMain() {
  _s();
  const {
    ROUTE_FRAGMENTS: {
      RF_KANTONSRAT,
      RF_GESCHAEFTE,
      RF_PERSONEN,
      RF_MITGLIEDER,
      RF_FRAKTIONEN,
      RF_WAHLKREISE,
      RF_KOMMISSIONEN,
      RF_SITZUNGEN
    },
    PAGE_HANDLES: {
      H_KANTONSRAT_GESCHAEFTE_FEED,
      H_KANTONSRAT_PERSONEN_FEED,
      H_KANTONSRAT_MITGLIEDER_FEED,
      H_KANTONSRAT_SITZUNGEN_FEED
    }
  } = SYS_CONFIG;
  const {
    lang
  } = useParams();
  const {
    pathname
  } = useLocation();
  const page = usePathHandle();
  const l_kantonsrat = useLang('kantonsrat');
  const l_metas = useLang('metas');
  const isMainCB = useCallback(() => {
    if (pathname === createLangPathByParam(lang, '/kantonsrat')) return true;
    return false;
  }, [pathname, lang]);
  const useCaseCB = useCallback(() => {
    if (page === H_KANTONSRAT_PERSONEN_FEED) {
      return 'personen';
    } else if (page === H_KANTONSRAT_MITGLIEDER_FEED) {
      return 'mitglieder';
    } else if (page === H_KANTONSRAT_SITZUNGEN_FEED) {
      return 'sitzungen';
    } else if (page === H_KANTONSRAT_GESCHAEFTE_FEED) {
      return 'geschaefte';
    }
    return null;
  }, [page]);
  const isMain = isMainCB();
  const useCase = useCaseCB();
  return <main className="page_1">

            <div className="side_bx">
                <BreadcrumbsKantonsrat />
            </div>

            {useCase ? <SearchInputGroup useCase={useCase} /> : null}

            {isMain ? <>
                    <h1>{l_kantonsrat('h1_kantonsrat')}</h1>
                    <div className="kr_main">
                        <section className="intro_sec">
                            <h2>{l_metas('c_personen')}</h2>
                            <p>{l_metas('m_d_kantonsrat_person_feed')}</p>
                            <NavLink className="btn_1" to={createLangPathByParam(lang, `/${RF_KANTONSRAT}/${RF_PERSONEN}`)}>{l_metas('c_personen')}</NavLink>
                        </section>
                        <section className="intro_sec">
                            <h2>{l_metas('c_mitglieder')}</h2>
                            <p>{l_metas('m_d_kantonsrat_mitglieder_feed')}</p>
                            <NavLink className="btn_1" to={createLangPathByParam(lang, `/${RF_KANTONSRAT}/${RF_MITGLIEDER}`)}>{l_kantonsrat('l_members')}</NavLink>
                        </section>
                        <section className="intro_sec">
                            <h2>{l_metas('c_fraktionen')}</h2>
                            <p>{l_metas('m_d_kantonsrat_fraktionen_feed')}</p>
                            <NavLink className="btn_1" to={createLangPathByParam(lang, `/${RF_KANTONSRAT}/${RF_FRAKTIONEN}`)}>{l_kantonsrat('l_fraktionen')}</NavLink>
                        </section>
                        <section className="intro_sec">
                            <h2>{l_metas('c_wahlkreise')}</h2>
                            <p>{l_metas('m_d_kantonsrat_wahlkreise_feed')}</p>
                            <NavLink className="btn_1" to={createLangPathByParam(lang, `/${RF_KANTONSRAT}/${RF_WAHLKREISE}`)}>{l_kantonsrat('l_wahlkreise')}</NavLink>
                        </section>
                        <section className="intro_sec">
                            <h2>{l_metas('c_kommissionen')}</h2>
                            <p>{l_metas('m_d_kantonsrat_kommissionen_feed')}</p>
                            <NavLink className="btn_1" to={createLangPathByParam(lang, `/${RF_KANTONSRAT}/${RF_KOMMISSIONEN}`)}>{l_kantonsrat('l_kommissionen')}</NavLink>
                        </section>
                        <section className="intro_sec">
                            <h2>{l_metas('c_sitzungen')}</h2>
                            <p>{l_metas('m_d_kantonsrat_sitzungen_feed')}</p>
                            <NavLink className="btn_1" to={createLangPathByParam(lang, `/${RF_KANTONSRAT}/${RF_SITZUNGEN}`)}>{l_kantonsrat('l_sitzungen')}</NavLink>
                        </section>
                        <section className="intro_sec">
                            <h2>{l_metas('c_geschaefte')}</h2>
                            <p>{l_metas('m_d_kantonsrat_geschaefte_item')}</p>
                            <NavLink className="btn_1" to={createLangPathByParam(lang, `/${RF_KANTONSRAT}/${RF_GESCHAEFTE}`)}>{l_kantonsrat('l_geschaefte')}</NavLink>
                        </section>
                    </div>
                </> : null}
            <Outlet />

        </main>;
}
_s(KantonsratMain, "/6wZORluY6XJsHdKll37tKbWSsQ=", true, function () {
  return [useParams, useLocation, usePathHandle, useLang, useLang];
});
_c = KantonsratMain;
var _c;
$RefreshReg$(_c, "KantonsratMain");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;